import { Form, Formik, Field } from "formik";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { login } from "../../../services";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { images } from "../../../assets/images";
import { Oval } from "react-loader-spinner";
import { login as loginReducer } from "../../../store/userSlice";
import { setProgress } from "../../../store/progressSlice";

export const Login = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const initialValues = {
        email: '',
        password: '',
    }

    const handleSubmit = (values) => {
        dispatch(setProgress(0))
        setIsLoading(true);
        login(values.email, values.password).then(response => {
            setIsLoading(false);
            const data = response.data;
            dispatch(loginReducer(data, "user/login"))
            const params = new URLSearchParams(location.search);
            const redirectUrl = params.get('redirect') || '/';
            window.location.href = redirectUrl;
        }).catch(err => {
            setIsLoading(false);
            setErrorMessage(err.response.data.msg);
        })
    }

    const LoginSchema = Yup.object().shape({
        email: Yup.string().min(5, "Too Short!").max(100, "Too Long!").required("Required"),
        password: Yup.string().min(5, "Too Short!").max(100, "Too Long!").required("Required")
    });

    return (
        <main className="has-black-bg has-full-height">
            <header className="w-[90%] m-auto pt-12">
                <a href="https://skinsagency.com">
                    <img src={images.logo} alt="logo" />
                </a>
            </header>
            <div className="h-full flex flex-col pt-40">
                <article className="flex flex-col justify-self-center items-center justify-between gap-2">
                    <h1 className="text-8xl text-light-grey font-light">Login</h1>
                    {errorMessage !== "" ? (
                        <p className="has-yellow-text">
                            {errorMessage}
                        </p>
                    ) : (
                        <></>
                    )}
                    <Formik
                        initialValues={initialValues}
                        onSubmit={(values => handleSubmit(values))}
                        autoComplete="off"
                        validationSchema={LoginSchema}
                    >
                        {({ errors, touched }) => (
                            <Form method="POST" autoComplete="off" className="flex flex-col gap-5">
                                <fieldset className="flex flex-col items-start">
                                    <Field
                                        name="email"
                                        type="text"
                                        className="has-border-bottom"
                                        placeholder="Email"
                                        autoComplete="off" />
                                    {errors.email && touched.email ? (
                                        <p className="has-red-text w-full text-xs mt-1">{errors.email}</p>
                                    ) : null}
                                </fieldset>
                                <fieldset className="flex flex-col">
                                    <Field
                                        name="password"
                                        type="password"
                                        className="has-border-bottom"
                                        placeholder="Password"
                                        autoComplete="off" />
                                    {errors.password && touched.password ? (
                                        <div className="has-red-text w-full text-xs mt-1">{errors.password}</div>
                                    ) : null}
                                </fieldset>
                                {/* <Link to="/forgot-password" className="has-yellow-text text-sm mt-[-5px] mb-[-5px]">Forgot Password?</Link> */}
                                <button className="btn btn-login" type="submit">
                                    {isLoading ? (
                                        <Oval
                                            height={30}
                                            width={50}
                                            color="black"
                                            secondaryColor="black"
                                        />
                                    ) : (
                                        <span className="text-[black]">Login</span>
                                    )}
                                </button>
                                <Link to="/register">Don't have an account? <span className="has-yellow-text">Click here to register.</span></Link>
                            </Form>
                        )}
                    </Formik>
                </article>
            </div>
        </main >
    )
}